import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TemplateContextGuardModule } from '@y42/core/template-context-guard';
import { TimeAgoModule } from '@y42/date-time';
import { GitBranchListComponent } from './git-branch-list.component';

@NgModule({
  imports: [
    CommonModule,
    MatMenuModule,
    MatTooltipModule,
    FontAwesomeModule,
    TimeAgoModule,
    TemplateContextGuardModule,
  ],
  declarations: [GitBranchListComponent],
  exports: [GitBranchListComponent],
})
export class GitBranchListModule {}
